import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentAddedWitnessesDto extends EpimsBaseEntityDto {
    
   EventTypeId: string;
   Name: string;
   PhoneNo: string;  
   Email: string; 
   Description: string; 
    
   IncidentTrackingNo: string;
    

}